import { getCurrentOrgId } from "@/lib/org-context";

const API_BASE = import.meta.env.VITE_API_URL || "";

function buildHeaders(extra?: HeadersInit): Record<string, string> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  const orgId = getCurrentOrgId();
  if (orgId) headers["X-Org-Id"] = orgId;
  if (extra) {
    const entries =
      extra instanceof Headers
        ? Array.from(extra.entries())
        : Object.entries(extra);
    for (const [k, v] of entries) {
      headers[k] = v as string;
    }
  }
  return headers;
}

export async function api<T>(
  path: string,
  options?: RequestInit
): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    ...options,
    headers: buildHeaders(options?.headers),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || `Request failed: ${res.status}`);
  }
  if (res.status === 204) return undefined as T;
  return res.json();
}
